export default "__VITE_ASSET__Dpgz2HfO__"